import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';

@Injectable({
	providedIn: 'root',
})
export class FireInsuranceAgentsDispatch {
	@Dispatch()
	Search = (searchTerm: string, companyId?: string): actions.Search =>
		new actions.Search({ searchTerm, companyId });
}
